export const strictValidArray = (arr)=>{
    return arr && Array.isArray(arr)
}

export const strictValidString = (str)=>{
    return str && typeof str === "string";
}


// WEBPACK FOOTER //
// ./src/utils/common.js